import { useSearchParams } from './useSearchParams';

export const useSearchParam = (paramName: string) => useSearchParams().get(paramName);
